import { useData } from "../data/DataContext";
import { ContentHeader } from "../components/ContentHeader";
import { EntityCard } from "../components/EntityCard";
import { ESTATES } from "../nav";

export function ClientsTab() {
  const data = useData();
  const items = (data.commandCenter?.estates.clients ?? []).slice().sort((a, b) => a.name.localeCompare(b.name));
  const meta = ESTATES.find((e) => e.id === "clients")!;
  return (
    <>
      <ContentHeader title={meta.label} count={items.length} description={meta.desc} />
      <div className="grid">{items.map((it) => <EntityCard key={it.id} item={it} />)}</div>
    </>
  );
}
